import CartContext from '../../context/CartContext'

const CartSummary = () => (
  <CartContext.Consumer>
    {value => {
      const {cartList} = value
      let total = 0
      cartList.map(each => {
        total += each.price * each.quantity
        return total
      })

      return (
        <div>
          <h1>Product Summary</h1>
          <p>Order Total : {total}</p>
          <p>Total Items : {cartList.length}</p>
          <button type="button">Check Out</button>
        </div>
      )
    }}
  </CartContext.Consumer>
)

export default CartSummary
